export enum CustomerListActions {
  RENAME = 'RENAME',
  DUPLICATE_LIST = 'DUPLICATE_LIST',
  ADD_ITEMS_TO_CART = 'ADD_ITEMS_TO_CART',
  ADD_ITEMS_TO_PROJECT = 'ADD_ITEMS_TO_PROJECT',
  DELETE_LIST = 'DELETE_LIST',
}

export type CustomerListActionType = keyof typeof CustomerListActions
